import axios from 'axios'

export default {
  methods: {
    apiCall (c, cbfnc) {
      var vm = this
      var r
      // Überprüfen, ob c ein Array ist
      if (this.$_.isArray(c)) r = c
      else {
        r = []
        r.push(c)
      }

      axios.post(this.$globals.API_URL, JSON.stringify(r), {withCredentials: true})
        .then(response => {
          this.$_.forEach(response.data, function (value) {
            if (value.hasOwnProperty('error') && parseInt(value.error.code) === -10000) {
              vm.auth.valid = false
              return false
            }
          })

          cbfnc(response.data)
        })
    }
  }
}
